module.exports = __webpack_public_path__ + "img/noti6.c40324c2.jpeg";